import React, {useEffect, useRef, useState} from 'react'

import {Modal, Spin, Form, Select, Radio, Input, Space, Button, Tooltip} from 'antd5'
import {
  DeleteOutlined,
  DownCircleOutlined, UpCircleOutlined,
  CloudDownloadOutlined, CloudUploadOutlined
} from "@ant-design/icons";
import {connect} from "dva";
import {useUpdateEffect} from "ahooks";

import { Base64 } from 'js-base64';

import {utils_tool} from "@/tool";
import {modelUtils} from "@/utils";
import {WizTableForm} from "@/containers/common";


const {useForm, useWatch} = Form
const {copy} = utils_tool

const clipboard_prefix = 'learningScorePreference|'

const categoryConfig = WizTableForm.Config.categoryInfo(this, {apiParams: {type: 13, state: 1}})

import './learningScorePreference.less'

const Index = (
  {
    dispatch,
    pathId,
    trainPathLearningScoreLoading,
    getInfoByIdRes,
    saveRes,

    callback,
  },
) => {
  const [form] = useForm();
  const type = useWatch('type', form);
  const levelList = useWatch('levelList', form);
  const requiredList = useWatch('requiredList', form)
  const {getFieldValue, setFieldsValue, validateFields, resetFields} = form
  const [formData, setFormData] = useState({})
  const ref_TextArea = useRef()

  useEffect(() => {
    dispatch({
      type: 'trainPathLearningScore/getInfoById',
      payload: {
        key: `trainPathLearningScore@getInfoById`,
        apiParams: {
          pathId: pathId,
        },
      },
    })
  }, [])

  useUpdateEffect(() => {
    const {success, msg, data} = getInfoByIdRes
    if (!success) {
      wizNotice.error(msg || '系统运行繁忙');
      return;
    }
    const {
      pathId,
      pathName,
      type: pathType,
      categoryId,
      categoryName,
      requiredStageList,
      levelList,
    } = data || {}

    setFormData({
      pathId: pathId,
      pathName: pathName,
      type: pathType,
      categoryId,
      categoryName,
      requiredList: requiredStageList?.map(item => {
        const {stageId, stageName, lv, score} = item || {}
        const data = {
          id: stageId,
          name: stageName,
        }
        data.index = lv;
        if (pathType === 0) {
          data.score = score
        }
        return data;
      }),
      levelList: levelList,
    })
  }, [getInfoByIdRes])

  useUpdateEffect(() => {
    const {success, msg, data} = saveRes
    if (!success) {
      wizNotice.error(msg || '系统运行繁忙');
      return;
    }
    wizNotice.success(msg);
    callback && callback();
  }, [saveRes])

  useUpdateEffect(() => {
    reset()
  }, [formData])

  const submit = () => {
    validateFields()
      .then(values => {
        console.log(values)
        const {
          type,
          categoryId,
          requiredList,
        } = values || {}

        return {
          pathId: values.pathId || pathId,
          pathType: type,
          categoryId,
          requiredStageList: requiredList?.map(item => {
            const data = {stageId: item.id, lv: item.index}
            if (type === 0) {
              data.score = item.score
            }
            return data
          }),
          levelList: levelList?.map((item, index) => ({
            name: item.name,
            ...(
              type === 0 ?
                {
                  passScore: item.passScore,
                  score: item.score,
                  count: item.count
                } : {}
            ),
          })),
        }
      })
      .then(data => {
        console.log('============>data:', data)
        dispatch({
          type: 'trainPathLearningScore/save',
          payload: {
            key: `trainPathLearningScore@save`,
            apiParams: {
              ...data,
            },
          },
        })
      })
      .catch(err => {
        console.log(err)
      })
  }, reset = () => {
    resetFields()
    setFieldsValue(formData)
  }

  const cloudDownload = () => {
    const {
      type: pathType,
      pathName,
      requiredList,
      levelList,
    } = formData || {}
    console.log('formData', formData)
    if ([null, undefined, -1].includes(pathType)) {
      wizNotice.error('请先配置保存后在进行复制');
      return;
    }

    const data = {
      pathType,
      pathName,
      requiredList: requiredList?.map(({name, index, score}) => (pathType === 0 ? {name, index, score} : {name, index})),
      levelList: levelList?.map(({name, passScore, score, count}) => (pathType === 0 ? {name, passScore, score, count} : {name})),
    }
    const content = Base64.encodeURI(`${clipboard_prefix}${JSON.stringify(data)}`)

    if(copy && copy(content)) {
      wizNotice.success('已复制到剪切板');
    } else {
      Modal.info({
        title: '配置内容',
        content: (
          <div>
            <div>请手动进行复制下列内容</div>
            <Input.TextArea size={{minRows: 4}} value={content}/>
          </div>
        )
      })
    }
  }
  const cloudUpload = () => {
    const callback = (text) => {
      try {
        text = !!text ? Base64.decode(text) : undefined;
        if (!text || !text.startsWith(clipboard_prefix)) {
          wizNotice.error('请检查剪切板配置');
          return;
        }

        const {
          pathType,
          pathName,
          requiredList,
          levelList,
        } = JSON.parse(text.substring(clipboard_prefix.length));

        const _data = {
          type: pathType,
          requiredList: formData?.requiredList?.map(item => {
            const {name} = item || {}
            const {
              index,
              score,
            } = requiredList?.find(item => item?.name === name) || {}

            return {
              ...item,
              ...(pathType === 0 ? {index, score} : {index})
            }
          }),
          levelList: levelList?.map(item => {
            const {name, passScore, score, count} = item || {}
            return pathType === 0 ? {name, passScore, score, count} : {name}
          })
        }
        setFieldsValue({...formData, ..._data})
        wizNotice.success(`导入路径:${pathName},人效配置成功`);
      } catch (e) {
        console.error('导入配置出现错误:', e)
        wizNotice.error('请检查剪切板配置');
      }
    }

    // 检查浏览器是否支持 Clipboard API
    if (navigator.clipboard) {
      // 读取剪切板中的文本
      navigator.clipboard.readText().then(text => {
        console.log('剪切板中的文本:', text);
        callback(text)
      }).catch(err => {
        console.error('无法读取剪切板内容: ', err);
      });
    } else {
      console.log('当前浏览器不支持 Clipboard API');
      Modal.confirm({
        title: '导入配置',
        content: <Input.TextArea ref={ref_TextArea} placeholder={'请将剪贴板内的配置粘贴'}/>,
        onOk: () => callback(ref_TextArea.current?.resizableTextArea?.textArea?.value),
      })
    }
  }

  return (
    <div className={'learningScorePreference'}>
      <Spin spinning={trainPathLearningScoreLoading}>
        <Form form={form}>
          <Form.Item
            label={'路径名称'}
            name={'pathId'}
            labelCol={{span: 4}}
            wrapperCol={{span: 20}}
          >
            {formData?.pathName}
            <div className={'operation-button'}>
              <Tooltip title={'复制配置到剪切板'}>
                <CloudDownloadOutlined onClick={cloudDownload}/>
              </Tooltip>
              <Tooltip title={'从剪切板导入'}>
                <CloudUploadOutlined onClick={cloudUpload}/>
              </Tooltip>
            </div>
          </Form.Item>
          <Form.Item
            label={'路径类型'}
            name={'type'}
            labelCol={{span: 4}}
            wrapperCol={{span: 20}}
            rules={[{required: true, message: '请选择路径类型'}]}
          >
            <Radio.Group>
              <Radio value={0}>销售</Radio>
              <Radio value={1}>售后</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label={'证书分类'}
            name={'categoryId'}
            labelCol={{span: 4}}
            wrapperCol={{span: 14}}
            // rules={[{required: type === 0, message: '请选择证书分类'}]}
          >
            <WizTableForm {...categoryConfig} initRows={formData?.categoryId ? [{id: formData.categoryId, name: formData.categoryName}] : []} selectType={'radio'} placeholder={'请选择证书分类'}/>
          </Form.Item>
          <Form.Item label={'必修阶段能效积分配置'}>
            <Form.List name={'requiredList'}>
              {
                (fields, {move}, {errors}) => {
                  return (
                    <div className={'fields-dynamic-list'}>
                      {
                        fields.map((field, index) => {
                          return (
                            <Form.Item required={false}>
                              <Space block={true} key={index} align={'start'}>
                                <Form.Item name={[field.name, 'id']} hidden={true}>
                                  <Input disabled={true}/>
                                </Form.Item>
                                <Form.Item name={[field.name, 'name']}>
                                  <Text/>
                                </Form.Item>
                                <Form.Item name={[field.name, 'index']}>
                                  <Select placeholder={'请选择等级'} style={{width: 220}} allowClear>
                                    {
                                      levelList?.map((item, index) => (
                                        <Select.Option
                                          key={index}
                                          value={index}>
                                          {item?.name || ' '}
                                        </Select.Option>
                                      ))
                                    }
                                  </Select>
                                </Form.Item>
                                {
                                  type === 0 ?
                                    <Form.Item
                                      name={[field.name, 'score']}
                                      rules={[
                                        {
                                          required: ![null, undefined].includes(getFieldValue(['requiredList', field.name, 'index'])),
                                          message: '等级配置后分数必须填写'
                                        },
                                        {pattern: /^[0-9]*$/, message: '只允许使用数字'},
                                        {max: 5, message: '最多支持5位字符'},
                                      ]}
                                    >
                                      <Input placeholder="请输入分值" suffix={'分'}/>
                                    </Form.Item> : undefined
                                }
                                {/* <Form.Item> */}
                                {/*   <UpCircleOutlined style={{fontSize: 18}} onClick={() => move(index, index - 1)}/> */}
                                {/*   &nbsp;&nbsp; */}
                                {/*   <DownCircleOutlined style={{fontSize: 18}} onClick={() => move(index, index + 1)}/> */}
                                {/* </Form.Item> */}
                              </Space>
                            </Form.Item>
                          )
                        })
                      }
                    </div>
                  )
                }
              }
            </Form.List>
          </Form.Item>
          {
            0 === type ?
              <Form.Item label={'选修阶段能效积分配置'}>
                <Form.List name={'levelList'}>
                  {
                    (fields, {}, {errors}) => {
                      return (
                        <div className={'fields-dynamic-list'}>
                          {
                            fields.map((field, index) => {
                              return (
                                <Form.Item required={false}>
                                  <Space block={true} align={'start'}>
                                    <Form.Item name={[field.name, 'name']}>
                                      <Text/>
                                    </Form.Item>
                                    <Form.Item>最多</Form.Item>
                                    <Form.Item
                                      name={[field.name, 'count']}
                                      rules={[
                                        {pattern: /^[0-9]*$/, message: '只允许使用数字'},
                                        {max: 5, message: '最多支持5位字符'},
                                      ]}
                                    >
                                      <Input style={{width: 100}}/>
                                    </Form.Item>
                                    <Form.Item>门</Form.Item>
                                    <Form.Item
                                      name={[field.name, 'score']}
                                      rules={[
                                        {pattern: /^[0-9]*$/, message: '只允许使用数字'},
                                        {max: 5, message: '最多支持5位字符'},
                                      ]}
                                    >
                                      <Input style={{width: 100}}/>
                                    </Form.Item>
                                    <Form.Item shouldUpdate={true}>
                                      {() =>
                                        <div>分,共 {parseInt(getFieldValue(['levelList', field.name, 'count']) || 0) * parseInt(getFieldValue(['levelList', field.name, 'score']) || 0)}分</div>}
                                    </Form.Item>
                                  </Space>
                                </Form.Item>
                              )
                            })
                          }
                        </div>
                      )
                    }
                  }
                </Form.List>
              </Form.Item> : undefined
          }
          <Form.Item label={'能效等级规则'}>
            <Form.List
              name={'levelList'}
              rules={[{
                validator: (_, value) => {
                  if (!value?.length) {
                    return Promise.reject(new Error('必须添加等级配置'));
                  }
                  return Promise.resolve();
                }
              }]}
            >
              {
                (fields, {add, remove, move}, {errors}) => {
                  return (
                    <div className={'fields-dynamic-list'}>
                      {
                        fields.map((field, index) => {
                          return (
                            <Form.Item required={false}>
                              <Space block={true} align={'start'} key={index}>
                                <Form.Item
                                  // noStyle
                                  name={[field.name, 'name']}
                                  rules={[{required: true, whitespace: true, message: '请输入等级名称'}]}
                                >
                                  <Input placeholder="请输入等级名称"/>
                                </Form.Item>
                                {
                                  type === 0 ?
                                    <Form.Item
                                      // noStyle
                                      name={[field.name, 'passScore']}
                                      rules={[
                                        {required: true, whitespace: true, message: '请输入分值'},
                                        {pattern: /^[0-9]*$/, message: '只允许使用数字'},
                                        {max: 7, message: '最多支持7位字符'},
                                      ]}
                                    >
                                      <Input placeholder="请输入分值" suffix={'分'}/>
                                    </Form.Item> : undefined
                                }
                                <Form.Item>
                                  <UpCircleOutlined style={{fontSize: 18}} onClick={() => move(index, index - 1)}/>
                                  &nbsp;&nbsp;
                                  <DownCircleOutlined style={{fontSize: 18}} onClick={() => move(index, index + 1)}/>
                                  &nbsp;&nbsp;
                                  <DeleteOutlined style={{fontSize: 18}} onClick={() => remove(field.name)}/>
                                </Form.Item>
                              </Space>
                            </Form.Item>
                          )
                        })
                      }
                      <Form.ErrorList errors={errors}/>
                      <Button type="dashed" onClick={() => add()} block>
                        添加
                      </Button>
                    </div>
                  )
                }
              }
            </Form.List>
          </Form.Item>
          <Form.Item style={{display: 'flex', justifyContent: 'center'}}>
            <Button type={'primary'} onClick={submit}>保存</Button>
            &nbsp;&nbsp;
            <Button onClick={reset}>重置</Button>
          </Form.Item>
        </Form>
      </Spin>
    </div>
  )
}

const Text = ({value}) => {
  return <div>{value}</div>
}


const mapStateToProps = (state, ownProps) => {
  const {trainPathLearningScore} = state;
  const getInfoById = modelUtils.getModelEntity(trainPathLearningScore, "trainPathLearningScore@getInfoById");
  const save = modelUtils.getModelEntity(trainPathLearningScore, "trainPathLearningScore@save");

  const loading = modelUtils.getLoadingState(state, ['trainPathLearningScore']);

  return {
    getInfoByIdRes: getInfoById,
    saveRes: save,
    ...loading,
  }
};
const options = {withRef: true};
export default connect(mapStateToProps, null, null, options)(Index);
